import { createContext } from 'react';

export function createService<T>(
  func: (...args: any[])=> T,
  initialValue: T | undefined = undefined,
) {
  return createContext(initialValue as T);
}
